import { render, staticRenderFns } from "./DiscoveryBrands.vue?vue&type=template&id=5d587d67"
import script from "./DiscoveryBrands.vue?vue&type=script&lang=js"
export * from "./DiscoveryBrands.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports